import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import store from './components/store'
import { Provider } from 'react-redux'
import Hydrate from './Hydrate'
import Generator from './app/Generator'
import Preview from './app/Preview'

if (document.getElementById('ichgehwaehleneuropawahl2024')) {
    ReactDOM.render(
        <React.StrictMode>
            <Provider store={store}>
                <Hydrate>
                    <App />
                </Hydrate>
            </Provider>
        </React.StrictMode>,
        document.getElementById('ichgehwaehleneuropawahl2024'),
    )
}

if (document.getElementById('ichgehwaehleneuropawahl2024-generator')) {
    ReactDOM.render(
        <React.StrictMode>
            <Provider store={store}>
                <Hydrate>
                    <Generator />
                </Hydrate>
            </Provider>
        </React.StrictMode>,
        document.getElementById('ichgehwaehleneuropawahl2024-generator'),
    )
}

if (document.getElementById('ichgehwaehleneuropawahl2024-preview')) {
    ReactDOM.render(
        <React.StrictMode>
            <Provider store={store}>
                <Hydrate>
                    <Preview />
                </Hydrate>
            </Provider>
        </React.StrictMode>,
        document.getElementById('ichgehwaehleneuropawahl2024-preview'),
    )
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
